export default "__VITE_PUBLIC_ASSET__8ab9f2df__"